import React from "react";

export default function NoMatch404() {
  return <h1 style={{ fontSize: "3rem" }}>404 Not Found</h1>;
}
